import React from 'react'
import { MainDiv } from '../Default/MainDiv'
import { MainContent } from './MainContent'


export const LiveStream=()=> {
  return (
    <>
    <MainDiv>
    <MainContent/>
    </MainDiv>
    </>
    
  )
}
